<div class="grid grid-auto-1 content md3-surface">
  <!--   <div style="height: 48px;"></div> -->
  <!--   <div class="" style="height: 48px;"> -->
  <!--     <div class="grid-auto-1 app-space-top_1" *ngFor="let color of worker.all"> -->
  <!--       <exg-checkbox [(ngModel)]="worker.blue" style="margin: unset"></exg-checkbox> -->
  <!--       <img [src]="'assets/images/worker_'+color+'.svg'" [alt]="color" style="width: 32px; height: 32px"> -->
  <!--     </div> -->
  <!--   </div> -->
  <div class="content width-500 md3-card-on-surface layout-auto-1-auto">
    <!-- Search Header -->
    <exg-search-bar (Search)="SummaryData.search($event)"
                    [placeholder]="getRessource('SearchHeaderPlaceholder')"
                    class="span-layout">
      <ng-template #rightTemplate>
        <i (click)="SummaryData.reloadData()" class="search-action far fa-sync"></i>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-filter"
               [class.fa-solid]="appSvc.metaInfo.uiFilterAktiv(SummaryData.uiFilter, 1).length > 0"
               [class.fa-regular]="appSvc.metaInfo.uiFilterAktiv(SummaryData.uiFilter, 1).length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCSummaryDataFilterControl
                            (onActivateFilter)="SummaryData.pageChanged(1);popup.close()"
                            [MetaInfo]="SummaryData.MetaInfo"
                            [visibility]="popup.visibility !== 'hidden'"
                            [showFilter]="true" [uiFilter]="SummaryData.uiFilter"
                            [uiSort]="SummaryData.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-sort-alt"
               [class.fa-solid]="SummaryData.uiSortAktiv().length > 0"
               [class.fa-regular]="SummaryData.uiSortAktiv().length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCSummaryDataSortControl
                            (onActivateFilter)="SummaryData.pageChanged(1);popup.close()"
                            [MetaInfo]="SummaryData.MetaInfo"
                            [visibility]="popup.visibility !== 'hidden'"
                            [showSort]="true" [uiFilter]="SummaryData.uiFilter"
                            [uiSort]="SummaryData.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-binoculars"
               [class.fa-solid]="appSvc.metaInfo.uiFilterAktiv(SummaryData.uiFilter, 2).length > 0"
               [class.fa-regular]="appSvc.metaInfo.uiFilterAktiv(SummaryData.uiFilter, 2).length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter (onActivateFilter)="SummaryData.pageChanged(1);popup.close()"
                            [MetaInfo]="SummaryData.MetaInfo" #VCSummaryDataSearchControl
                            [showSearch]="true" [uiFilter]="SummaryData.uiFilter"
                            [visibility]="popup.visibility !== 'hidden'"
                            [uiSort]="SummaryData.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <div class="search-action" *ngIf="excSecurity.isFeatured('TASKQSDISPO')">
          <i class="search-action fa-light" (click)="SummaryData.changeMultiRoute()"
             [class.fa-toggle-off]="mode === 'DL'"
             [class.fa-toggle-on]="mode === 'QS'"></i>
        </div>
        <i class="search-action fa-light fa-route" (click)="calcRoute()"></i>
      </ng-template>
    </exg-search-bar>
    <div class="content">
      <exg-data-list #SOlist selectKey="vorgID"
                     [headerText]="SummaryData.multiRoute ? ((mode === 'QS')?'QS Tasks auswählen':'Disponierende Tasks auswählen') : ''"
                     [displayState]="SummaryData.state"
                     [rowSource]="SummaryData.schadenortData"
                     [selectSourceRows]="SummaryData.selectedObjects"
                     (RowChange)="SummaryData.rowChange($event)"
                     (ItemSelect)="SummaryData.itemSelect($event)"
                     [allowSingleSelection]="!SummaryData.multiRoute"
                     [allowMultiSelection]="SummaryData.multiRoute">
        <ng-template #rowTemplate let-task>
          <div class="list-row-auto-1"
               [class.active2]="task?.marker">
            <div></div>
            <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
              <div class="list-metadata" style="margin-left:0">
                <div>
                  {{enumSvc.getEnumerationText('VorgangStatus', task.vorg_enmIdent_VorgangStatus)}} -
                  {{enumSvc.getEnumerationText('VorgangTyp', task.vorg_enmIdent_VorgangTyp)}}
                </div>
                <div>Auftraggeber: {{task.auAuftraggeberShort}} Schadenart: {{enumSvc.getEnumerationText('Schadenart',
                                                                                                         task.aue_enmIdent_SchadenArt)}}</div>
              </div>
              <div class="list-metadata ">
                <div
                  class="typo-right">{{task.vorgLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                <div class="typo-right">{{task.marker?.oeName}}</div>
              </div>
              <div style="height: 30px">
                <span class="typo-center">
                  <span [tooltip]="'Nicht Geprüft'" flow="right">
                    <i class="fa-solid fa-xmark c-red" style="font-size: 14px" *ngIf="!task.vorgCKD"></i>
                  </span>
                  <span [tooltip]="'Geprüft'" flow="right">
                    <i class="fa-solid fa-check c-green" style="font-size: 14px" *ngIf="task.vorgCKD"></i>
                  </span>
                </span>
                <span class="app-space-left">
                  <strong>{{task.vorgNr}}</strong> - {{task.aueSchadenNr}}
                </span>
              </div>
              <div class="typo-right">
                <i class="search-action fa-regular fa-chevron-right"
                   (click)="onClickOpenTaskCheckview(task)">
                </i>
              </div>
              <div class="span-2 typo-container-s-s-q app-space-left_none">
                <ng-container *ngIf="task.vorgBeschreibung && task.vorgBeschreibung.length > 0">
                  <span style="width: 148px">
                    {{enumSvc.getFieldCaption('Vorgang', 'vorgBeschreibung')}}:
                  </span>
                  <span class="typo-left"
                        *ngIf="SummaryData.selectedObjects[0] === task">
                    {{task.vorgBeschreibung}}
                  </span>
                  <span class="typo-left"
                        *ngIf="SummaryData.selectedObjects[0] !== task">
                    {{task.vorgBeschreibung.slice(0, 48)}}
                    {{task.vorgBeschreibung.length > 48 ? '...' : ''}}
                  </span>
                  <q></q>
                </ng-container>
                <ng-container *ngIf="task.vorgBearbeiter && task.vorgBearbeiter.length > 0">
                   <span style="width: 148px">
                    {{enumSvc.getFieldCaption('Vorgang', 'vorgBearbeiter')}}:
                  </span>
                  <span class="typo-left">
                    {{task.vorgBearbeiter}}
                  </span>
                  <q></q>
                </ng-container>
                <ng-container *ngIf="task.aueLetzterSachverstaendiger && task.aueLetzterSachverstaendiger.length > 0">
                  <span style="width: 148px">
                    {{enumSvc.getFieldCaption('AuftragE_EIS', 'aueLetzterSachverstaendiger')}}:
                  </span>
                  <span class="typo-left">
                    {{task.aueLetzterSachverstaendiger}}
                  </span>
                  <q></q>
                </ng-container>
              </div>
              <div class="span-2 list-secondary-text app-pad-top">
                <div><strong>{{task.aueVersicherungsnehmer}}</strong></div>
                <!--                 <div>{{task.adrZusatz}}</div> -->
                <!--                 <div>{{task.adrStr}} {{task.adrHNum}}</div> -->
                <div>{{task.adrPlz}} {{task.adrOrt}}</div>
              </div>
            </div>
          </div>
        </ng-template>
      </exg-data-list>
    </div>
    <!-- Pager -->
    <div class="span-layout app-pager">
      <div class="pager" style="display: grid; grid-template-columns: 1fr auto 1fr;">
        <div></div>
        <div><span>{{SummaryData?.selectedObjects?.length}} /  {{SummaryData?.schadenortData?.length}}</span></div>
        <div></div>
      </div>
    </div>
    <!--  <exg-pager (PageChange)="SummaryData.pageChanged($event)"
                 [pagingSource]="SummaryData.paging"
                 class="span-layout">
      </exg-pager>-->
  </div>
  <div class="content md3-card-on-surface">
    <app-disposition-map3 [oeList]="SummaryData?.oeData"
                          [places]="SummaryData?.schadenortData"
                          [dispoDefinition]="SummaryData?.data?.DispositionListDefinitionValues"
                          [taskObjects]="SummaryData.selectedObjects"
                          [doDistanceMatrix]="mode === 'DL'"
                          [busy] = "busy"
                          (OnAssign)="assignTasks($event)"
                          (OnPlaceClick)="placeClick($event)"
                          (OnSettingsChanged)="loadSummaryData()">
    </app-disposition-map3>
  </div>
</div>
